/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createListSubCategoriesResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ListSubCategoriesResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/categories/{category}
 */
export interface WithCategoryItemRequestBuilder extends BaseRequestBuilder<WithCategoryItemRequestBuilder> {
    /**
     * List all subcategories for a given category in an organization
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ListSubCategoriesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ListSubCategoriesResponse | undefined>;
    /**
     * List all subcategories for a given category in an organization
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithCategoryItemRequestBuilderUriTemplate = "{+baseurl}/api/categories/{category}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCategoryItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithCategoryItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createListSubCategoriesResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
